import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";
import DynamicFilterInput from "../../../Components/layouts/filter.inpit";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcBullish } from "react-icons/fc";
import {
  GroupedLineChart,
  LineChart,
  PolarChart,
  PieChart,
  FullMoonChart,
} from "./chart";
import { FcRatings } from "react-icons/fc";
import { FcPanorama } from "react-icons/fc";
import { FcLandscape } from "react-icons/fc";
import { FcReadingEbook } from "react-icons/fc";
import { FcApproval } from "react-icons/fc";
import "react-loading-skeleton/dist/skeleton.css";
import { BsArrowRightShort } from "react-icons/bs";
import { returnMonthDateYear } from "../../../Components/Functions/date.fun";

const EmailMatrics = () => {
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [sRefresh, setSrefresh] = useState(false);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
  });
  const [filters2, setFilters2] = useState({
    startdate: "",
    enddate: "",
  });
  const [page, setPage] = useState(1);
  const [page2, setPage2] = useState(1);

  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [emailLogs, SetEmailLogs] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [bannerData, setBannerData] = useState([]);
  const [totalClickCount, setTotalClickCount] = useState(0);
  const [emailCounteAndPerformanceRate, setEmailCounteAndPerformanceRate] =
    useState({});
  const [dailyQuota, setDailyQuota] = useState({});
  const [eventTypeBar, setEventTypeBar] = useState([]);
  const [emailSchedulesData, setEmailSchedulesData] = useState({});
  const [linkStats, setLinkStats] = useState({});

  const linkMap = {
    "studentTraining-link": {
      title: "Student Training",
      icon: <FcReadingEbook size={30} />,
    },
    "hm-masterclass": {
      title: "Hydroponic Masterclass",
      icon: (
        <img
          src="https://d502jbuhuh9wk.cloudfront.net/logos/65dc4780e4b0b60e6be0bdc1.png?v=1"
          alt="hydroponicmasterclass"
          width={30}
        />
      ),
    },
    "kryzen-link": {
      title: "Kryzen Website",
      icon: (
        <img
          src="https://kryzen.com/wp-content/uploads/2022/02/kryzen-logo-1.png"
          alt="kryzenlogo"
        />
      ),
    },
    "quotation-link": { title: "Quotation", icon: <FcRatings size={30} /> },
    "alpha-link": { title: "Alpha Website", icon: <FcApproval size={30} /> },
    "practicalTraining-link": {
      title: "Farm Training",
      icon: <FcLandscape size={30} />,
    },
  };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", "/bulkemail/getcount-of-mail-count")
      .then((res) => {
        if (res.status === 200) {
          setBannerData(res.data);
          const formatted = {};
          res.data.forEach((item) => {
            formatted[item.linkType] = {
              totalCount: item.totalCount,
              todayCount: item.todayCount,
            };
          });
          setLinkStats(formatted);
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", "/bulkemail/get-email-schedules")
      .then((res) => {
        if (res.status === 200) {
          setEmailSchedulesData(res.data);
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/bulkemail/email-metrics-all-data/", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setChartData(res.data.getAllEmailData);
          setTotalClickCount(res.data.totalClickCount);
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  const dataMap = Object.fromEntries(
    bannerData.map((item) => [item.linkType, item])
  );

  // Step 2: Merge both data and linkMap dynamically
  const mergedData = Object.keys({ ...dataMap, ...linkMap }).map(
    (linkType) => ({
      linkType,
      totalCount: dataMap[linkType]?.totalCount || 0,
      todayCount: dataMap[linkType]?.todayCount || 0,
      title: linkMap[linkType]?.title || "Unknown",
      icon: linkMap[linkType]?.icon || <FcPanorama size={30} />,
    })
  );

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/bulkemail/get-event-type", page2, filters2)
    )
      .then((res) => {
        if (res.status === 200) {
          setEventTypeBar(res.data);
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [sRefresh, page2]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", "/bulkemail/get-clickbounce-rate/")
      .then((res) => {
        if (res.status === 200) {
          setEmailCounteAndPerformanceRate(res.data);
          setDailyQuota(res.data.dailyQuota);
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);
  useEffect(() => {
    setLoading(true);
    performRequest("GET", "/bulkemail/email-logs/")
      .then((res) => {
        if (res.status === 200) {
          SetEmailLogs(res.data);
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcBullish className="me-2" style={{ color: "brown" }} />
                  Email Analytics
                </h2>
              </div>
            </div>
          </div>

          <h1
            className="text-center mt-2 hero-title display-5 fw-bold"
            style={{ fontSize: "30px" }}
          >
            UPCOMING SCHEDULED EMAILS
          </h1>

          <div className="row mt-5">
            <div className="col-12 col-md-3 col-lg-4">
              <div className="card bg-azure-lt card-sm">
                <div className="card-body">
                  <div className="">
                    <h5 className="text-center fs-1">
                      {emailSchedulesData?.upcomingFarmTrainingMails || 0} /
                      {emailSchedulesData?.totalFarmTrainingSentMails || 0}
                    </h5>

                    <div class="fw-bold text-center">Upcoming / Total Sent</div>
                    <div class="fw-bold text-center">Farm Training</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3 col-lg-4">
              <div className="card bg-azure-lt card-sm">
                <div className="card-body">
                  <div className="">
                    <h5 className="text-center fs-1">
                      {emailSchedulesData?.upcomingQuotationMails || 0} /
                      {emailSchedulesData?.totalQuotationSentMails || 0}
                    </h5>
                    <div className=" fw-bold text-center">
                      Upcoming / Total Sent
                    </div>
                    <div class="fw-bold text-center">Quotations</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3 col-lg-4">
              <div className="card bg-azure-lt card-sm">
                <div className="card-body">
                  <div className="">
                    <h5 className="text-center fs-1">
                      {emailSchedulesData?.upcomingFarmTrainingMails || 0} /
                      {emailSchedulesData?.totalSiteInspectionSentMails || 0}
                    </h5>
                    <div className=" fw-bold text-center">
                      Upcoming / Total Sent
                    </div>
                    <div class="fw-bold text-center">Site Inspection</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h1
            className="text-center mt-5 hero-title display-5 fw-bold"
            style={{ fontSize: "30px" }}
          >
            TOTAL CLICKS OVER THE TIME
          </h1>

          <div className="row mt-5">
            <div className="col-12 col-md-3 col-lg-4">
              <div className="card bg-azure-lt card-sm">
                <div className="card-body">
                  <div className="">
                    <h5 className="text-center fs-1">
                      {linkStats["hm-masterclass"]?.todayCount || 0} /
                      {linkStats["hm-masterclass"]?.totalCount || 0}
                    </h5>

                    <div class="fw-bold text-center">Today / Total Clicks</div>
                    <div class="fw-bold text-center">HM Masterclass</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3 col-lg-4">
              <div className="card bg-azure-lt card-sm">
                <div className="card-body">
                  <div className="">
                    <h5 className="text-center fs-1">
                      {linkStats["kryzen-link"]?.todayCount || 0} /
                      {linkStats["kryzen-link"]?.totalCount || 0}
                    </h5>
                    <div className=" fw-bold text-center">
                      Today / Total Clicks
                    </div>
                    <div class="fw-bold text-center">Kryzen Website</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3 col-lg-4">
              <div className="card bg-azure-lt card-sm">
                <div className="card-body">
                  <div className="">
                    <h5 className="text-center fs-1">
                      {linkStats["quotation-link"]?.todayCount || 0} /
                      {linkStats["quotation-link"]?.totalCount || 0}
                    </h5>
                    <div className=" fw-bold text-center">
                      Today / Total Clicks
                    </div>
                    <div class="fw-bold text-center">Quotation</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col-12 col-md-3 col-lg-6">
              <div className="card bg-azure-lt card-sm">
                <div className="card-body">
                  <div className="">
                    <h5 className="text-center fs-1">
                      {linkStats["alpha-link"]?.todayCount || 0} /
                      {linkStats["alpha-link"]?.totalCount || 0}
                    </h5>

                    <div class="fw-bold text-center">Today / Total Clicks</div>
                    <div class="fw-bold text-center">Alpha Website</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3 col-lg-6">
              <div className="card bg-azure-lt card-sm">
                <div className="card-body">
                  <div className="">
                    <h5 className="text-center fs-1">
                      {linkStats["practicalTraining-link"]?.todayCount || 0} /
                      {linkStats["practicalTraining-link"]?.totalCount || 0}
                    </h5>
                    <div className=" fw-bold text-center">
                      Today / Total Clicks
                    </div>
                    <div class="fw-bold text-center">Farm Training</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-5 p-2">
            <h1
              className="text-center display-5 hero-title  fw-bold"
              style={{ fontSize: "30px" }}
            >
              DAILY EMAILS DELIVERED OVERVIEW
            </h1>
            <div
              className="table-responsive mt-5  overflow-scroll"
              style={{ height: "400px" }}
            >
              <table className="table table-vcenter card-table">
                <thead>
                  <tr className=" border border-1">
                    <th>Level</th>
                    <th>Action</th>
                    <th>Status</th>
                    <th> Date</th>
                  </tr>
                </thead>
                <tbody className="border border-1">
                  {emailLogs &&
                    emailLogs?.map((el, index) => {
                      return (
                        <tr key={index}>
                          <td data-label="level">
                            <div>{el?.level || "NA"}</div>
                          </td>
                          <td data-label="action">
                            <div className="text-secondary">
                              {el?.message
                                ? el?.message?.action || el?.message?.cron
                                : "NA"}
                            </div>
                          </td>
                          <td data-label="Status">
                            <div>
                              {el?.message?.data
                                ? el?.message?.data[0]?.Status[0]?.Status ||
                                  el?.message?.cron
                                : el?.message?.message
                                ? el?.message.message
                                : "NA"}
                            </div>
                          </td>
                          <td data-label="date">
                            <div>
                              {el?.createdAt
                                ? returnMonthDateYear(el?.createdAt)
                                : "NA"}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>

          <div className="row row-deck mt-5">
            <div className="col-md-3 col-sm-12 py-2">
              {/* first filter section */}
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Total Clicks Filter</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className="accordion-body pt-0">
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Start Date:"
                              value={filters.startdate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  startdate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>

                          <div className="col-12">
                            <DynamicFilterInput
                              label="End Date:"
                              value={filters.enddate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  enddate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>

                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      startdate: "",
                                      enddate: "",
                                      diseasesName: "",
                                      typeOfDiseases: "",
                                    });
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-body d-none d-md-block">
                      <div className="row">
                        <h3>Total Clikcs Filter</h3>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="Start Date:"
                            value={filters.startdate}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                startdate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>

                        <div className="col-12">
                          <DynamicFilterInput
                            label="End Date:"
                            value={filters.enddate}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                enddate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>

                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    startdate: "",
                                    enddate: "",
                                  });
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                {chartData && (
                  <LineChart
                    displayData={chartData}
                    totalClickCount={totalClickCount}
                  />
                )}
              </div>
            </div>
          </div>

          {/* row*/}
          <div className="row gy-3 mt-5" style={{ height: "auto" }}>
            <div className="col-12 col-md-4">
              <div className="card p-3 text-center h-100">
                <h4>Email Performance Report</h4>
                <FullMoonChart data={emailCounteAndPerformanceRate} />
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div className="card p-3 text-center h-100">
                <h4>Email Distribution Report</h4>
                <PieChart eventData={emailCounteAndPerformanceRate} />
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div className="card p-3 text-center h-100">
                <h4>Email Daily Quota Overview</h4>
                <PolarChart data={dailyQuota} />
              </div>
            </div>
          </div>

          {/* Email Delivers */}
          <div className="row row-deck mt-5">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2">
                <div
                  id="faq-2"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-2"
                      >
                        <h3 className="m-1">Email Delivers</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-2"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-2"
                    >
                      <div className="accordion-body pt-0">
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Start Date:"
                              value={filters2.startdate}
                              onChange={(e) =>
                                setFilters2({
                                  ...filters2,
                                  startdate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>

                          <div className="col-12">
                            <DynamicFilterInput
                              label="End Date:"
                              value={filters2.enddate}
                              onChange={(e) =>
                                setFilters2({
                                  ...filters2,
                                  enddate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>

                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setSrefresh(!sRefresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters2({
                                      startdate: "",
                                      enddate: "",
                                    });
                                    setSrefresh(!sRefresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-body d-none d-md-block">
                      <div className="row">
                        <h3>Email Delivers</h3>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="Start Date:"
                            value={filters2.startdate}
                            onChange={(e) =>
                              setFilters2({
                                ...filters2,
                                startdate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>

                        <div className="col-12">
                          <DynamicFilterInput
                            label="End Date:"
                            value={filters2.enddate}
                            onChange={(e) =>
                              setFilters2({
                                ...filters2,
                                enddate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>
                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setSrefresh(!sRefresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters2({
                                    startdate: "",
                                    enddate: "",
                                  });
                                  setSrefresh(!sRefresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                {eventTypeBar && (
                  <GroupedLineChart
                    displayData={eventTypeBar}
                    totalClickCount={totalClickCount}
                  />
                )}
              </div>
            </div>

            <div className="col-12 py-2">{/* card */}</div>
          </div>

          {/* email Schedules */}
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default EmailMatrics;
